export const categories = [
  {
    slug: "kua",
    name: "塌房预警",
    en: "DANGER",
    desc: "私德与行为争议预警，抢在实锤前给出风险提示",
    icon: "ri-fire-line",
    tint: "red",
  },
  {
    slug: "fazhi",
    name: "法制咖锤",
    en: "VERDICT",
    desc: "涉及税务、合同、违法行为的落锤进展与通报梳理",
    icon: "ri-scales-3-line",
    tint: "amber",
  },
  {
    slug: "tax",
    name: "税务爆料",
    en: "TAX WATCH",
    desc: "阴阳合同、少缴漏缴、补税罚单的来龙去脉",
    icon: "ri-bill-line",
    tint: "red",
  },
  {
    slug: "contract",
    name: "合同纠纷",
    en: "CONTRACT",
    desc: "解约、天价片酬、对赌与片约纠纷的真相还原",
    icon: "ri-file-edit-line",
    tint: "amber",
  },
  {
    slug: "rule",
    name: "行业潜规则",
    en: "INSIDER",
    desc: "招商报价、数据水分、压价潜规则的业内揭秘",
    icon: "ri-eye-off-line",
    tint: "stone",
  },
  {
    slug: "proof",
    name: "实锤证据链",
    en: "EVIDENCE",
    desc: "从预告到实锤，整理时间线与关键证据节点",
    icon: "ri-focus-3-line",
    tint: "stone",
  },
];

export const navItems = [
  { id: "hero", label: "今日要闻", en: "HEADLINE" },
  { id: "columns", label: "栏目导览", en: "COLUMNS" },
  { id: "feed", label: "最新瓜闻", en: "LATEST" },
  { id: "evidence", label: "实锤证据链", en: "EVIDENCE" },
  { id: "topics", label: "深挖专题", en: "TOPICS" },
  { id: "insights", label: "潜规则解读", en: "INSIGHTS" },
  { id: "faq", label: "吃瓜FAQ", en: "FAQ" },
  { id: "about", label: "关于我们", en: "ABOUT" },
];

export const hotTrends = [
  {
    rank: 1,
    title: "顶流男演员被指签订阴阳合同",
    cat: "税务爆料",
    heat: "186.4万",
    trend: "up",
  },
  {
    rank: 2,
    title: "新生代爱豆品牌连夜撤物料",
    cat: "塌房预警",
    heat: "203.1万",
    trend: "new",
  },
  {
    rank: 3,
    title: "选秀断层出道位疑似刷票",
    cat: "实锤证据链",
    heat: "221.9万",
    trend: "flat",
  },
  {
    rank: 4,
    title: "一线女星天价解约官司开打",
    cat: "合同纠纷",
    heat: "142.9万",
    trend: "up",
  },
  {
    rank: 5,
    title: "爆款综艺招商报价被指注水",
    cat: "行业潜规则",
    heat: "96.8万",
    trend: "down",
  },
];

export const faqs = [
  {
    q: "这里的“塌房预警”和“法制咖锤”有什么区别？",
    a: "「塌房预警」侧重行为与私德层面的争议信号，通常发生在实锤之前，我们提醒读者关注风险而非直接定性；「法制咖锤」则聚焦已经进入法律程序的案件，例如税务稽查、合同诉讼与违法通报，必须有权威信源作为支撑才会上线。",
  },
  {
    q: "你们如何保证爆料的真实性？",
    a: "我们坚持“三步核验”：一看信源是否可追溯，二看材料是否具备原始性与唯一性，三看是否有官方通报或权威第三方佐证。凡处于“疑似”阶段的内容都会明确标注“待核实”，并在实锤落地后第一时间更新证据时间线。",
  },
  {
    q: "为什么有的瓜是匿名演员、有的又是具体说法？",
    a: "涉及可能构成侵权的对象，我们会采用角色化表述（如“某顶流男演员”）保护隐私并降低名誉风险；而对于行业机制、合同条款、数据口径这类不指向具体个人的事实，则可以给出更具体的分析。我们始终把“事实清楚、主体审慎”放在首位。",
  },
  {
    q: "证据链里的时间线可以信任吗？",
    a: "证据链板块是我们最审慎的内容。每个时间节点都标注信源类型（官方通报、信源披露、公开数据、网友整理），并区分“已证实”“待核实”与“单方说法”。读者可以用文末给的四维度评分自行交叉验证。",
  },
  {
    q: "如何向你们投稿或提供爆料线索？",
    a: "欢迎通过页面底部「爆料投稿」栏目向我们提供线索。为保证安全，请尽量附带可核验的材料来源或凭证线索，避免直接传播未经确认的个人隐私。所有来稿我们都将在保密前提下审核，重大线索会转交事实核查流程。",
  },
];

export const testimonials = [
  {
    name: "阿澈",
    role: "追星七年 · 泛娱乐读者",
    text: "以前吃瓜总是一头雾水，现在看你们把预告和实锤串成时间线，终于能分清哪些是谣言、哪些真有下文了。",
    avatar: "阿",
  },
  {
    name: "老陈",
    role: "影视行业 · 制片助理",
    text: "作为圈内人，某些“潜规则解读”写得挺到点子上，尤其是招商报价和保量条款那块，确实是行话。",
    avatar: "陈",
  },
  {
    name: "Lemon",
    role: "公众号主理人",
    text: "证据链那个可信度评分很实用，我转载时都会先按你们的四维度筛一遍，少踩了不少雷。",
    avatar: "L",
  },
];

export const stats = [
  { num: "128+", label: "本周热搜事件" },
  { num: "46", label: "实锤证据链跟进" },
  { num: "6", label: "核心栏目主题" },
  { num: "24h", label: "全网热点滚动追踪" },
];